import AssembleiaItem from 'components/__SHARED__/AssembleiaItem/AssembleiaItem';
import { UserIcon } from 'components/Icons';
import { AssemblyModalitiesNumber } from 'helpers/enums/Assembleia';
import { AssociadoRoutePath } from 'library/Routes';
import translation from 'locales/translation';
import moment from 'moment';
import {
  ButtonThemes,
  Col,
  Modal,
  ModalSizes,
  Row,
} from 'plataforma-fundacao-componentes';
import { ModalProps } from 'plataforma-fundacao-componentes/dist/components/modal/Modal';
import React from 'react';
import { useSelector } from 'react-redux';
import { IReducer } from 'store/Reducer';
import { history } from 'store/Store';
import styles from './ConsultaEventoModal.scss';
const rootClassName = styles.rootClassName;
interface ConsultaEventosModalProps extends ModalProps {
  cpfCnpj: string;
}

export default function ConsultaEventosModal(props: ConsultaEventosModalProps) {
  const { consultaByCpfCnpj } = useSelector(
    (state: IReducer) => state.assembleias
  );

  return (
    <Modal
      size={ModalSizes.ExtraLarge}
      title={translation.ConsultaModal.title[`${consultaByCpfCnpj.length > 0}`]}
      modalKey={props.modalKey}
      onClose={props.onClose}
      preventMaskExit={props.preventMaskExit}
      mobileOn={props.mobileOn}
      footer={
        !consultaByCpfCnpj ||
        !consultaByCpfCnpj.length ||
        consultaByCpfCnpj.some(
          (assembleia) => assembleia.idModo !== AssemblyModalitiesNumber.OFFLINE
        )
          ? [
              {
                theme: ButtonThemes.Primary,
                onClick: () => {
                  props.onClose?.(props.modalKey);
                  setTimeout(() => {
                    history.push(AssociadoRoutePath);
                  }, 300);
                },
                children:
                  translation.ConsultaModal[
                    consultaByCpfCnpj.length > 0
                      ? 'buttonLabel'
                      : 'acessarMesmoAssim'
                  ],
                leftIcon: consultaByCpfCnpj.length > 0 ? '' : <UserIcon />,
              },
            ]
          : []
      }
    >
      {consultaByCpfCnpj!?.length ? (
        <React.Fragment>
          <Row>
            <Col className={`${rootClassName}-subtitle nunito`}>
              {translation.ConsultaModal.subtitle}
            </Col>
          </Row>
          {consultaByCpfCnpj!?.map((item) => {
            const getEndereco = () => {
              if (
                item.idModo === AssemblyModalitiesNumber.HIBRIDO_DIGITAL_AGENCIA
              )
                return translation.ConsultaModal.enderecoAgencia;
              return `${item.endereco}${
                item.bairro ? ` - ${item.bairro}` : ''
              }${item.cep ? ` - ${item.cep}` : ''} - ${item.cidade} - ${
                item.estado
              }${
                item.referencia
                  ? ` ${translation.ConsultaModal.referencia}: ${item.referencia}.`
                  : '.'
              }`;
            };

            const formatData = (data: string) =>
              moment(data).format('DD/MM/YYYY - HH:mm');

            return (
              <Row key={item.oidEvento}>
                <Col>
                  <AssembleiaItem
                    language={{
                      dataInicio: translation.ConsultaModal.dataInicio,
                      dataTermino: translation.ConsultaModal.dataTermino,
                      enderecoDigital:
                        translation.ConsultaModal.enderecoDigital,
                      presencial:
                        item.idModo ===
                        AssemblyModalitiesNumber.HIBRIDO_DIGITAL_AGENCIA
                          ? translation.ConsultaModal.agencia
                          : translation.ConsultaModal.presencial,
                    }}
                    onClick={() => {
                      if (item.idModo === AssemblyModalitiesNumber.OFFLINE)
                        return;
                      sessionStorage.setItem(
                        'assembleia_id',
                        String(item.oidEvento)
                      );
                      props.onClose?.(props.modalKey);
                      setTimeout(() => {
                        history.push(AssociadoRoutePath);
                      }, 400);
                    }}
                    nomeCooperativa={item.nomeCooperativa}
                    modo={item.idModo}
                    dataInicio={
                      item.idModo ===
                      AssemblyModalitiesNumber.HIBRIDO_PRESENCIAL_DIGITAL
                        ? formatData(item.dataInicioEventoOnline!)
                        : formatData(item.dataInicioEvento)
                    }
                    dataTermino={
                      item.idModo ===
                      AssemblyModalitiesNumber.HIBRIDO_PRESENCIAL_DIGITAL
                        ? formatData(item.dataFimEventoOnline!)
                        : formatData(item.dataFimEvento)
                    }
                    presencial={
                      item.idModo !== AssemblyModalitiesNumber.ONLINE
                        ? {
                            dataInicio: formatData(
                              item.idModo ===
                                AssemblyModalitiesNumber.HIBRIDO_DIGITAL_AGENCIA
                                ? item.dataInicioEventoOnline!
                                : item.dataInicioEvento!
                            ),
                            dataTermino: formatData(
                              item.idModo ===
                                AssemblyModalitiesNumber.HIBRIDO_DIGITAL_AGENCIA
                                ? item.dataFimEventoOnline!
                                : item.dataFimEvento!
                            ),
                            endereco: getEndereco(),
                          }
                        : undefined
                    }
                  />
                </Col>
              </Row>
            );
          })}
        </React.Fragment>
      ) : (
        <Row>
          <Col>{translation.ConsultaModal.emptyMessage}</Col>
        </Row>
      )}
    </Modal>
  );
}
